import { ResolvedIntlConfig } from 'react-intl';

export const DEFAULT_RICH_TEXT_ELEMENTS: ResolvedIntlConfig['defaultRichTextElements'] = {
  strong: (str: string[]) => <strong>{str}</strong>,
};
